<template>
  <div
    class="signup-wizard-step"
    :class="{ done: step.number < selectedStepNumber, current: step.number === selectedStepNumber }"
  >
    <div class="signup-wizard-name">
      {{ step.name }}
    </div>

    <div class="signup-wizard-description">
      {{ step.description }}
    </div>

    <div class="signup-wizard-progress" />

    <div class="signup-wizard-point" />
  </div>
</template>

<script>
export default {
  name: 'WizardStepsItem',
  props: {
    step: {
      type: Object,
      required: true
    },
    selectedStepNumber: {
      type: Number,
      required: true
    }
  }
}
</script>
